"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeScheduler = void 0;
const configuration_1 = require("../../configuration/configuration");
const post_1 = require("./post");
const INTERVAL_ADJUSTMENT_FACTOR = 2;
const emptyBatch = {
    keys: [],
    values: [],
};
function makeScheduler(_a, storageStrategy, authTokenFactory, applicationHeaderFactory, fetch) {
    var _b;
    var { url, prefix, scheduler } = _a;
    if (fetch === void 0) { fetch = (_b = globalThis.fetch) === null || _b === void 0 ? void 0 : _b.bind(globalThis); }
    const schedulerConf = scheduler !== null && scheduler !== void 0 ? scheduler : configuration_1.DefaultSchedulerConfiguration;
    let scheduleInterval = schedulerConf.defaultInterval;
    let nextTaskScheduled;
    let isRunning = false;
    async function runTask() {
        var _a;
        const events = (_a = (await (storageStrategy === null || storageStrategy === void 0 ? void 0 : storageStrategy.batchGet(schedulerConf.batchSize)))) !== null && _a !== void 0 ? _a : emptyBatch;
        let count = events.keys.length;
        if (count > 0) {
            const payload = prefixMessages(prefix, events);
            const response = await (0, post_1.post)(url !== null && url !== void 0 ? url : 'api/log', payload, authTokenFactory, applicationHeaderFactory, fetch);
            if (!response.ok) {
                count = 0;
            }
        }
        if (schedulerConf.retryPolicy === 'dropOnFail' || count > 0) {
            await (storageStrategy === null || storageStrategy === void 0 ? void 0 : storageStrategy.batchRemove(events.keys));
        }
        adjustScheduleInterval(count);
        scheduleNextTask();
    }
    function adjustScheduleInterval(lastBatchSize) {
        const { min, max } = schedulerConf.range;
        const lessThanTypicalBatchSize = lastBatchSize < schedulerConf.batchSize;
        const adjustedInterval = lessThanTypicalBatchSize
            ? scheduleInterval * INTERVAL_ADJUSTMENT_FACTOR
            : scheduleInterval / INTERVAL_ADJUSTMENT_FACTOR;
        scheduleInterval = clamp(adjustedInterval, min, max);
    }
    function scheduleNextTask() {
        nextTaskScheduled = setTimeout(runTask, scheduleInterval);
    }
    return {
        isRunning() {
            return isRunning;
        },
        suspend() {
            if (isRunning) {
                isRunning = false;
                clearTimeout(nextTaskScheduled);
            }
        },
        resume() {
            if (!isRunning) {
                isRunning = true;
                scheduleNextTask();
            }
        },
    };
}
exports.makeScheduler = makeScheduler;
function prefixMessages(prefix, events) {
    if (prefix == null) {
        return events;
    }
    return events.values.map((log) => (Object.assign(Object.assign({}, log), { messageTemplate: prefix + log.messageTemplate })));
}
function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
}
//# sourceMappingURL=server-log-scheduler.js.map